import SiteConfig from '../config';

const SEPARATOR = ' | ';

/**
 * Compose a page title from a page-specific label plus the brand (FOX2-77).
 *
 * Three templates needed the same `Label | Foxbox Digital` shape, and each had
 * its own copy of it — case studies appended the suffix unconditionally, so a
 * study whose editor-set SEO title already ended in the brand shipped with it
 * twice ("… | Foxbox Digital | Foxbox Digital"). This centralises the rule and
 * makes it idempotent.
 *
 * Returns undefined for an empty label so callers fall through to MainLayout's
 * sitewide default rather than emitting a bare " | Foxbox Digital".
 */
export const withSiteName = (label?: string | null): string | undefined => {
  const trimmed = label?.trim();
  if (!trimmed) {
    return undefined;
  }
  // Already brand-suffixed — an editor typed the full title by hand. Match the whole
  // separator, not the bare brand: "Partner with Foxbox Digital" is prose that still
  // needs the suffix, and "… Foxbox Digital." would otherwise be double-branded.
  if (trimmed.toLowerCase().endsWith(`${SEPARATOR}${SiteConfig.name}`.toLowerCase())) {
    return trimmed;
  }
  return `${trimmed}${SEPARATOR}${SiteConfig.name}`;
};

export default withSiteName;
